// Localized "2 days ago" via the browser's Intl (no per-string i18n / pluralization needed).
// Shared by the candidate list recency line and the activity feed.
export function relativeTime(dateStr, lang) {
  if (!dateStr) return "";
  const diffMs = new Date(dateStr).getTime() - Date.now();
  const rtf = new Intl.RelativeTimeFormat(lang || "en", { numeric: "auto" });
  const mins = Math.round(diffMs / 60000);
  if (Math.abs(mins) < 1) return rtf.format(0, "second"); // "now"
  if (Math.abs(mins) < 60) return rtf.format(mins, "minute");
  const hrs = Math.round(mins / 60);
  if (Math.abs(hrs) < 24) return rtf.format(hrs, "hour");
  const days = Math.round(hrs / 24);
  if (Math.abs(days) < 7) return rtf.format(days, "day");
  if (Math.abs(days) < 31) return rtf.format(Math.round(days / 7), "week");
  return rtf.format(Math.round(days / 30), "month");
}

// Calendar-day grouping for feed headers: "Today" / "Yesterday" / a localized long date.
export function dayKey(dateStr) {
  return new Date(dateStr).toDateString();
}
// Absolute date+time for document lists. Pass i18n.language so a German UI does not
// inherit the browser's en-US locale ("8/25/2026, 10:30:39 AM").
export function formatDateTime(dateStr, lang) {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleString(lang || "de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function dayLabel(dateStr, lang, t) {
  const d = new Date(dateStr);
  const now = new Date();
  const startOf = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diffDays = Math.round((startOf(now) - startOf(d)) / 86400000);
  if (diffDays === 0) return t("today");
  if (diffDays === 1) return t("yesterday");
  return d.toLocaleDateString(lang || "en", { weekday: "long", day: "2-digit", month: "long" });
}
